document.addEventListener('DOMContentLoaded', () => {
  document.documentElement.classList.add('pp-os-ready');

  document.querySelectorAll('[data-pp-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const header = button.closest('.pp-header');
      const expanded = header.classList.toggle('is-open');
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-pp-secret]').forEach((root) => {
    const trigger = root.querySelector('[data-pp-secret-trigger]');
    const panel = root.querySelector('[data-pp-secret-panel]');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', () => {
      const opening = panel.hasAttribute('hidden');
      panel.toggleAttribute('hidden', !opening);
      trigger.setAttribute('aria-expanded', opening ? 'true' : 'false');
    });
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-pp-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });

    document.querySelectorAll('.pp-section, .pp-card').forEach((node) => observer.observe(node));
  }

  document.querySelectorAll('[data-pp-product-inventory]').forEach((inventoryNode) => {
    const productCard = inventoryNode.closest('.pp-card');
    const variantSelect = productCard?.querySelector('select[name="id"]');
    if (!variantSelect) return;

    const updateInventory = () => {
      const option = variantSelect.selectedOptions[0];
      if (!option || option.dataset.inventoryTracked !== 'true') {
        inventoryNode.hidden = true;
        return;
      }

      const quantity = Number(option.dataset.inventoryQuantity || 0);
      const available = option.dataset.available === 'true';
      inventoryNode.hidden = false;
      inventoryNode.classList.toggle('pp-inventory-signal--low', available && quantity > 0 && quantity <= 5);
      inventoryNode.textContent = available && quantity > 0 ? `Live remaining: ${quantity}` : 'Signal depleted';
    };

    variantSelect.addEventListener('change', updateInventory);
    updateInventory();
  });

  document.querySelectorAll('[data-pp-countdown]').forEach((root) => {
    const releaseAt = new Date(root.dataset.releaseAt);
    const completeText = root.dataset.completeText || 'Transmission released.';
    const status = root.parentElement?.querySelector('[data-pp-countdown-status]');
    const daysNode = root.querySelector('[data-pp-countdown-days]');
    const hoursNode = root.querySelector('[data-pp-countdown-hours]');
    const minutesNode = root.querySelector('[data-pp-countdown-minutes]');
    const secondsNode = root.querySelector('[data-pp-countdown-seconds]');

    if (Number.isNaN(releaseAt.getTime())) return;

    const pad = (value) => String(value).padStart(2, '0');
    const updateCountdown = () => {
      const remaining = releaseAt.getTime() - Date.now();
      if (remaining <= 0) {
        daysNode.textContent = '00';
        hoursNode.textContent = '00';
        minutesNode.textContent = '00';
        secondsNode.textContent = '00';
        if (status) status.textContent = completeText;
        return false;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      daysNode.textContent = pad(days);
      hoursNode.textContent = pad(hours);
      minutesNode.textContent = pad(minutes);
      secondsNode.textContent = pad(seconds);
      return true;
    };

    if (updateCountdown()) {
      const timer = window.setInterval(() => {
        if (!updateCountdown()) window.clearInterval(timer);
      }, 1000);
    }
  });

  document.querySelectorAll('[data-pp-game]').forEach((root) => {
    const canvas = root.querySelector('.pp-game__canvas');
    const ctx = canvas.getContext('2d');
    const scoreNode = root.querySelector('[data-pp-game-score]');
    const livesNode = root.querySelector('[data-pp-game-lives]');
    const message = root.querySelector('[data-pp-game-message]');
    const startButton = root.querySelector('[data-pp-game-start]');
    const winScore = Number(root.dataset.winScore || 8);
    const discountCode = root.dataset.discountCode || 'TURESTRL';
    const ufoSize = Number(root.dataset.ufoSize || 90);
    const headSize = Number(root.dataset.headSize || 70);
    const asteroidScale = Number(root.dataset.asteroidScale || 230) / 100;
    const keys = { left: false, right: false, thrust: false, fire: false };
    const ufo = new Image();
    const head = new Image();
    const asteroidArt = new Image();
    const hasUfo = Boolean(root.dataset.ufoSrc);
    const hasHead = Boolean(root.dataset.headSrc);
    const hasAsteroidArt = Boolean(root.dataset.asteroidSrc);
    if (hasUfo) ufo.src = root.dataset.ufoSrc;
    if (hasHead) head.src = root.dataset.headSrc;
    if (hasAsteroidArt) asteroidArt.src = root.dataset.asteroidSrc;

    let ship;
    let bullets = [];
    let asteroids = [];
    let particles = [];
    let score = 0;
    let lives = 3;
    let running = false;
    let won = false;
    let lastShot = 0;
    let animationId = 0;

    const resetShip = () => {
      ship = {
        x: canvas.width / 2,
        y: canvas.height / 2,
        vx: 0,
        vy: 0,
        angle: -Math.PI / 2,
        radius: 30,
        invincible: 90
      };
    };

    const wrap = (obj) => {
      if (obj.x < -60) obj.x = canvas.width + 60;
      if (obj.x > canvas.width + 60) obj.x = -60;
      if (obj.y < -60) obj.y = canvas.height + 60;
      if (obj.y > canvas.height + 60) obj.y = -60;
    };

    const spawnAsteroids = () => {
      asteroids = Array.from({ length: Math.max(5, winScore) }, (_, index) => {
        const side = index % 4;
        const radius = 28 + Math.random() * 36;
        return {
          x: side < 2 ? Math.random() * canvas.width : side === 2 ? -40 : canvas.width + 40,
          y: side >= 2 ? Math.random() * canvas.height : side === 0 ? -40 : canvas.height + 40,
          vx: (Math.random() - .5) * 2.2,
          vy: (Math.random() - .5) * 2.2,
          radius,
          spin: (Math.random() - .5) * .04,
          angle: Math.random() * Math.PI * 2,
          points: Array.from({ length: 9 }, () => .72 + Math.random() * .42)
        };
      });
    };

    const showMessage = (title, body) => {
      message.innerHTML = `<h3>${title}</h3><p>${body}</p>`;
      message.style.display = 'block';
      message.classList.add('is-visible');
    };

    const hideMessage = () => {
      message.classList.remove('is-visible');
      message.style.display = 'none';
    };

    const start = () => {
      score = 0;
      lives = 3;
      bullets = [];
      particles = [];
      won = false;
      running = true;
      resetShip();
      spawnAsteroids();
      scoreNode.textContent = score;
      livesNode.textContent = lives;
      hideMessage();
      cancelAnimationFrame(animationId);
      loop();
    };

    const shoot = () => {
      const now = performance.now();
      if (now - lastShot < 180) return;
      lastShot = now;
      bullets.push({
        x: ship.x + Math.cos(ship.angle) * 32,
        y: ship.y + Math.sin(ship.angle) * 32,
        vx: ship.vx + Math.cos(ship.angle) * 7,
        vy: ship.vy + Math.sin(ship.angle) * 7,
        life: 58,
        radius: 4
      });
    };

    const burst = (x, y, color = '#b6ff00') => {
      for (let i = 0; i < 14; i += 1) {
        particles.push({
          x,
          y,
          vx: (Math.random() - .5) * 5,
          vy: (Math.random() - .5) * 5,
          life: 24 + Math.random() * 20,
          color
        });
      }
    };

    const applyWinDiscount = () => {
      showMessage('Congratulations, signal cleared.', `Coupon code unlocked: ${discountCode}. Applying it to your cart now...`);
      window.setTimeout(() => {
        window.location.href = `/discount/${encodeURIComponent(discountCode)}?redirect=/cart`;
      }, 2200);
    };

    const collide = (a, b) => {
      const dx = a.x - b.x;
      const dy = a.y - b.y;
      const radius = a.radius + b.radius;
      return dx * dx + dy * dy < radius * radius;
    };

    const update = () => {
      if (keys.left) ship.angle -= .075;
      if (keys.right) ship.angle += .075;
      if (keys.thrust) {
        ship.vx += Math.cos(ship.angle) * .16;
        ship.vy += Math.sin(ship.angle) * .16;
        particles.push({
          x: ship.x - Math.cos(ship.angle) * 32,
          y: ship.y - Math.sin(ship.angle) * 32,
          vx: -Math.cos(ship.angle) * 1.4 + (Math.random() - .5),
          vy: -Math.sin(ship.angle) * 1.4 + (Math.random() - .5),
          life: 14,
          color: '#ff3c14'
        });
      }
      if (keys.fire) shoot();

      ship.x += ship.vx;
      ship.y += ship.vy;
      ship.vx *= .992;
      ship.vy *= .992;
      ship.invincible = Math.max(0, ship.invincible - 1);
      wrap(ship);

      bullets.forEach((bullet) => {
        bullet.x += bullet.vx;
        bullet.y += bullet.vy;
        bullet.life -= 1;
        wrap(bullet);
      });
      bullets = bullets.filter((bullet) => bullet.life > 0);

      asteroids.forEach((asteroid) => {
        asteroid.x += asteroid.vx;
        asteroid.y += asteroid.vy;
        asteroid.angle += asteroid.spin;
        wrap(asteroid);
      });

      particles.forEach((particle) => {
        particle.x += particle.vx;
        particle.y += particle.vy;
        particle.life -= 1;
      });
      particles = particles.filter((particle) => particle.life > 0);

      bullets.forEach((bullet) => {
        asteroids.forEach((asteroid) => {
          if (!asteroid.dead && !bullet.dead && collide(bullet, asteroid)) {
            asteroid.dead = true;
            bullet.dead = true;
            score += 1;
            scoreNode.textContent = score;
            burst(asteroid.x, asteroid.y);
          }
        });
      });
      bullets = bullets.filter((bullet) => !bullet.dead);
      asteroids = asteroids.filter((asteroid) => !asteroid.dead);

      if (ship.invincible === 0) {
        asteroids.forEach((asteroid) => {
          if (collide(ship, asteroid)) {
            lives -= 1;
            livesNode.textContent = lives;
            burst(ship.x, ship.y, '#ff3c14');
            if (lives <= 0) {
              running = false;
              showMessage('Signal lost.', 'The asteroid field overwhelmed Naes. Launch again to unlock the code.');
            } else {
              resetShip();
            }
          }
        });
      }

      if (!won && score >= winScore) {
        won = true;
        running = false;
        applyWinDiscount();
      }
    };

    const drawStars = () => {
      ctx.fillStyle = '#020303';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = 'rgba(182,255,0,.55)';
      for (let i = 0; i < 90; i += 1) {
        const x = (i * 137.5 + performance.now() * .01) % canvas.width;
        const y = (i * 71.3) % canvas.height;
        ctx.fillRect(x, y, i % 5 === 0 ? 2 : 1, 1);
      }
    };

    const drawShip = () => {
      ctx.save();
      ctx.translate(ship.x, ship.y);
      ctx.rotate(ship.angle + Math.PI / 2);
      ctx.globalAlpha = ship.invincible > 0 && Math.floor(ship.invincible / 6) % 2 === 0 ? .45 : 1;
      if (hasUfo && ufo.complete) {
        const ufoWidth = ufoSize;
        const ufoHeight = ufoSize * .7;
        ctx.drawImage(ufo, -ufoWidth / 2, -ufoHeight / 2 + 6, ufoWidth, ufoHeight);
      } else {
        ctx.beginPath();
        ctx.moveTo(0, -ufoSize * .38);
        ctx.lineTo(ufoSize * .31, ufoSize * .31);
        ctx.lineTo(0, ufoSize * .18);
        ctx.lineTo(-ufoSize * .31, ufoSize * .31);
        ctx.closePath();
        ctx.strokeStyle = '#ff3c14';
        ctx.lineWidth = 3;
        ctx.shadowColor = '#ff3c14';
        ctx.shadowBlur = 14;
        ctx.stroke();
      }
      if (hasHead && head.complete) {
        ctx.drawImage(head, -headSize / 2, -ufoSize * .42 - headSize * .62, headSize, headSize);
      }
      ctx.restore();
    };

    const drawAsteroid = (asteroid) => {
      ctx.save();
      ctx.translate(asteroid.x, asteroid.y);
      ctx.rotate(asteroid.angle);
      ctx.shadowColor = '#b6ff00';
      ctx.shadowBlur = 12;
      if (hasAsteroidArt && asteroidArt.complete) {
        const size = asteroid.radius * asteroidScale;
        ctx.drawImage(asteroidArt, -size / 2, -size / 2, size, size);
      } else {
        ctx.beginPath();
        asteroid.points.forEach((scale, index) => {
          const angle = (Math.PI * 2 * index) / asteroid.points.length;
          const x = Math.cos(angle) * asteroid.radius * scale;
          const y = Math.sin(angle) * asteroid.radius * scale;
          if (index === 0) ctx.moveTo(x, y);
          else ctx.lineTo(x, y);
        });
        ctx.closePath();
        ctx.strokeStyle = '#b6ff00';
        ctx.lineWidth = 2;
        ctx.stroke();
      }
      ctx.restore();
    };

    const draw = () => {
      drawStars();
      asteroids.forEach(drawAsteroid);
      ctx.fillStyle = '#ff3c14';
      bullets.forEach((bullet) => {
        ctx.beginPath();
        ctx.arc(bullet.x, bullet.y, bullet.radius, 0, Math.PI * 2);
        ctx.fill();
      });
      particles.forEach((particle) => {
        ctx.globalAlpha = Math.max(0, particle.life / 34);
        ctx.fillStyle = particle.color;
        ctx.fillRect(particle.x, particle.y, 3, 3);
      });
      ctx.globalAlpha = 1;
      drawShip();
    };

    const loop = () => {
      if (running) update();
      draw();
      if (running) animationId = requestAnimationFrame(loop);
    };

    const keyMap = {
      ArrowLeft: 'left',
      a: 'left',
      A: 'left',
      ArrowRight: 'right',
      d: 'right',
      D: 'right',
      ArrowUp: 'thrust',
      w: 'thrust',
      W: 'thrust',
      ' ': 'fire'
    };

    document.addEventListener('keydown', (event) => {
      if (!root.matches(':hover') && document.activeElement !== canvas) return;
      const action = keyMap[event.key];
      if (action) {
        keys[action] = true;
        event.preventDefault();
      }
    });

    document.addEventListener('keyup', (event) => {
      const action = keyMap[event.key];
      if (action) keys[action] = false;
    });

    root.querySelectorAll('[data-pp-control]').forEach((button) => {
      const action = button.dataset.ppControl;
      const set = (value) => {
        keys[action] = value;
      };
      button.addEventListener('pointerdown', (event) => {
        event.preventDefault();
        button.setPointerCapture?.(event.pointerId);
        set(true);
      });
      button.addEventListener('pointerup', (event) => {
        event.preventDefault();
        set(false);
      });
      button.addEventListener('pointercancel', (event) => {
        event.preventDefault();
        set(false);
      });
      button.addEventListener('pointerleave', () => set(false));
      button.addEventListener('dblclick', (event) => event.preventDefault());
    });

    startButton.addEventListener('click', (event) => {
      event.preventDefault();
      start();
    });
    root.addEventListener('touchmove', (event) => event.preventDefault(), { passive: false });
    root.addEventListener('gesturestart', (event) => event.preventDefault());
    canvas.setAttribute('tabindex', '0');
    resetShip();
    draw();
  });
});
